import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import {
  FaConfig,
  FaIconLibrary,
  FontAwesomeModule,
} from '@fortawesome/angular-fontawesome';
import { faBook } from '@fortawesome/free-solid-svg-icons';
import {
  IonApp,
  IonButton,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonMenuToggle,
  IonRouterOutlet,
  IonSplitPane,
  IonTitle,
  IonToolbar,
  ModalController,
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';

import { FabContactComponent } from '../../../common/components/fab-contact/fab-contact.component';
import { ProgressBarComponent } from '../../../common/components/progress-bar/progress-bar.component';
import { UserLoginListItemComponent } from '../../../common/components/side-menu/user-login-list-item/user-login-list-item.component';
import { SwitchThemeButtonComponent } from '../../../common/components/switch-theme-button/switch-theme-button.component';
import { PwaService } from '../../../common/services/pwa.service';
import { environment } from '../environments/environment';
import { TutorialComponent } from './components/tutorial/tutorial.component';
import { fontAwesomeIcons, ionicIcons } from './icons.const';

@Component({
  selector: 'pail-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IonSplitPane,
    IonApp,
    IonMenu,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButton,
    IonIcon,
    IonContent,
    IonList,
    IonMenuToggle,
    IonItem,
    IonLabel,
    IonFooter,
    IonRouterOutlet,
    FabContactComponent,
    SwitchThemeButtonComponent,
    UserLoginListItemComponent,
    ProgressBarComponent,
    RouterLink,
    AsyncPipe,
    RouterLinkActive,
    FontAwesomeModule,
  ],
})
export class AppComponent {
  public readonly showFabContactButtons =
    environment.featureFlipping.contactFabButton;
  public readonly userSettings = environment.featureFlipping.strapiUserSettings;
  public readonly environment = environment;
  private readonly modalController = inject(ModalController);
  private readonly pwaService = inject(PwaService);
  private readonly faIconLibrary = inject(FaIconLibrary);
  private readonly faConfig = inject(FaConfig);

  public constructor() {
    this.pwaService.init();
    this.faConfig.defaultPrefix = 'fas';
    this.faConfig.fallbackIcon = faBook;
    this.faConfig.fixedWidth = true;
    this.faIconLibrary.addIcons(...fontAwesomeIcons);
    addIcons(ionicIcons);
  }

  public async openTutorialModal(): Promise<void> {
    const tutorialModal = await this.modalController.create({
      component: TutorialComponent,
    });
    return tutorialModal.present();
  }
}
